import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { FridgeCrudService } from 'src/app/shared/services/fridge-crud.service';
import { Fridge } from 'src/app/shared/interfaces/fridge';


@Component({
  selector: 'app-fridges',
  templateUrl: './fridges.component.html',
  styleUrls: ['./fridges.component.scss']
})
export class FridgesComponent implements OnInit {

  fridges: Fridge[];
  fridge: Fridge;
  selectedFridges: Fridge[] = [];

  fridgeDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private fridgeService : FridgeCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'Fridges'}
    ];

    this.fridges = [];
    this.fridge = { } as Fridge ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.fridgeService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.fridges = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : Fridge = jsonItem as Fridge;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.fridges.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    //this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.fridgeService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.fridges);
            doc.save('fridges.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.fridges);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "fridges");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedFridges);
      // console.log('SAVEC CSV LOCATIONS ', this.fridges);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedFridges, 'fridges', exportCols);
   // this.exportService.exportToCsv(this.fridges, 'fridges', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.fridge = {} as Fridge;
    this.submitted = false;
    this.fridgeDialog = true;
  }

  deleteSelectedFridges() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected fridges?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.fridges = this.fridges.filter(val => !this.selectedFridges.includes(val));
            
            this.selectedFridges.forEach( fridge => this.fridgeService.delete(fridge.$key));
            this.selectedFridges = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Fridgess Deleted', life: 3000});
        }
    });
  }

  editFridge(fridge: Fridge) {
    this.fridge = {...fridge};
    this.fridgeDialog = true;
  }

  deleteFridge(fridge: Fridge) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + fridge.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.fridges = this.fridges.filter(val => val.$key !== fridge.$key);
            this.fridge = {} as Fridge;
            this.fridgeService.delete(fridge.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'Fridge Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.fridgeDialog = false;
    this.submitted = false;
  }

  saveFridge() {
    this.submitted = true;

    if ( this.fridge.name.trim() ) {
      if (this.fridge.$key) {
          this.fridges[this.findIndexById(this.fridge.$key)] = this.fridge;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'Fridge Updated', life: 3000});
          this.fridgeService.update(this.fridge);
        } else {
          this.fridge.position = this.fridges.length;
          this.fridgeService.add(this.fridge);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'Fridge Created', life: 3000});
      this.fridges = [...this.fridges];
    }

    this.fridgeDialog = false;
    this.fridge = { } as Fridge;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.fridges.length; i++) {
        if (this.fridges[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeFridge(fridge : Fridge) {
    this.fridgeService.update(fridge);
  }

  completePosition(fridge : Fridge) {
    if ( this.newPosition > -1 ) {
        fridge.position = this.newPosition;
        fridge = this.checkPositionLimits(fridge);
        this.reorderElements(fridge);
        //this.updateDB(fridge);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.fridges);
    // const myClonedArray = [];
    // this.fridges.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.fridges.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.fridges.length - 1 - event.dropIndex;
    const fridgeToMove = this.fridges[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.fridges[index] = this.fridges[index+1];
        this.fridges[index].position = index;
        this.fridgeService.update(this.fridges[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.fridges[index] = this.fridges[index-1];
        this.fridges[index].position = index;
        this.fridgeService.update(this.fridges[index]);
      }
    } 
    this.fridges[endIndex] = fridgeToMove;
    this.fridges[endIndex].position = endIndex;
    this.fridgeService.update(this.fridges[endIndex]);
  }

  // onFieldEdit(fridge: Spray, fieldName: string): void {
  //   //console.log(this.fridges);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + fridge[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       fridge.position = this.newPosition;
  //       fridge = this.checkPositionLimits(fridge);
  //       this.reorderElements(fridge);
  //       //this.updateDB(fridge);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(fridge);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.fridges.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, fridge: Fridge) {
    // console.log("event" +event);
    if (fridge.position != null && fridge.position > -1) {
      this.previousPosition = fridge.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(fridge: Fridge) {
    console.log('check ',fridge.position + ' ' + this.fridges.length);
    if (!fridge.position) {
     // console.log('check 1');
      return this.fridge;
    }
    if (fridge.position < 0) {
      fridge.position = 0;
      // console.log('check 2');
      return fridge;
    }
    if (fridge.position > this.fridges.length) {
      fridge.position = this.fridges.length - 1;
    //  console.log('check 3', fridge.position);
      return fridge;
    }
   // console.log('check 4');
    return fridge;
  }

  async reorderElements(fridge: Fridge) {
    this.newPosition = this.newPosition  > this.fridges.length ? this.fridges.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === fridge.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const fridgeToMove = this.fridges[startIndex];
   // console.log('Item to move: ', this.fridges[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.fridges);
        console.log('Item to +1: ', this.fridges[index+1]);

        this.fridges[index] = this.fridges[index+1];
        this.fridges[index].position = index;
        // console.log('Move: ', this.fridges[index+1]);
        // console.log('Move pos: ', this.fridges[index].position);
        //await this.updateDB(this.fridges[index]);
        this.fridgeService.update(this.fridges[index]);
     //   console.log('Update DB: ', this.fridges[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.fridges[index] = this.fridges[index-1];
        this.fridges[index].position = index;
        this.fridgeService.update(this.fridges[index]);
      }
    } 
    this.fridges[endIndex] = fridgeToMove;
    this.fridges[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.fridgeService.update(this.fridges[endIndex]);
    
    // const myClonedArray = [];
    // this.fridges.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.fridges = myClonedArray;
   // this.getAllRecords();
  }
}
